export enum FormSectionTitleTypes {
  primary = 'primary',
  secondary = 'secondary',
}
